// extracted by mini-css-extract-plugin
export default {"firstStickyColumnCell":"styles_firstStickyColumnCell__8+RrV"};